import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

interface IEditorProps {
  textData: string;
  setData: (data: string) => void;
}

const useStyles = makeStyles(() => ({
  editorContainer: {
    minHeight: 36,
  },
}));

const Editor: FC<IEditorProps> = ({ textData, setData }) => {
  const classes = useStyles();

  const custom_config = {
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "italic",
        "link",
        "bulletedList",
        "numberedList",
        "|",
        "blockQuote",
        "insertTable",
        "|",
        "undo",
        "redo",
      ],
      shouldNotGroupWhenFull: false,
    },
  };

  return (
    <CKEditor
      className={classes.editorContainer}
      editor={ClassicEditor}
      config={custom_config}
      data={textData}
      onChange={(_, editor) => {
        const data = editor.getData();
        setData(data);
      }}
      onReady={(editor) => {
        editor.editing.view.focus();
      }}
    />
  );
};

export default Editor;
